/* отсуп от границ viewport */
export var SIDE_GAP = 8;
export var INITIAL_X_TRANSFORM = 18;
export var INITIAL_Y_TRANSFORM = 9;
export var ROUNDING_COMPENSATION_TRANSFORM = 3;